module.exports = __webpack_public_path__ + "img/macStep3_2.fbebe62d.png";